import styled from 'styled-components';

export const TagInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px;
`;
export const SelectTagWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0 -20px;
  gap: 5px;
  cursor: pointer;
`;
